import { createClient, ContentfulClientApi } from "contentful";
const deepReduce = require("deep-reduce");
const unflatten = require("flat").unflatten;

export default class ContentfulHelper {
    private client: ContentfulClientApi;
    private SPACE_ID = "f5iqwtj7p8rg";
    private ACCESS_TOKEN = "69939b03890d29013134d5c4332147a2f05b6de20a59812368b5f72131aeb1b7";

    constructor() {
        this.client = createClient({
            space: this.SPACE_ID,
            accessToken: this.ACCESS_TOKEN
        });
    }

    public async getEntry(id: string): Promise<{}> {
        const response = await this.client.getEntry(id, {
            include: 10,
        });
        return this.transformResponse(response.fields);
    }

    private transformResponse = (response) => {
        let reduced = deepReduce(response, this.flattenStrings.bind(this));
        const unflattened = unflatten(reduced);
        return unflattened;
    }

    // store all values which are strings to reduced[path].
    private flattenStrings = (reduced, value, path) => {
        path = path.replace(/fields./g, "");
        if (path.indexOf(".sys.") > -1) {
            // do nothing
        } else if (typeof value === "string" || typeof value === "number") {
            reduced[path] = value;
        }
        return reduced;
    }
}
